module.exports = __webpack_public_path__ + "static/media/item_7_9_comp.3ab65acf.png";